import {Component, ElementRef, Injectable, Input, OnChanges, SimpleChanges} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {DomHelperService} from 'app/global/dom-helper.service';
import {GlobalService} from 'app/global/global.service';
import {Block} from 'app/interfaces/blocks';
import {Checkboxfield} from 'app/interfaces/checkboxfield';
import {DatepickerField} from 'app/interfaces/datepickerfield';
import {DroplistField} from 'app/interfaces/droplistfields';
import {Field} from 'app/interfaces/fields';
import {MultichoiceField} from 'app/interfaces/multichoicefield';
import {Signaturefield} from 'app/interfaces/signaturefield';
import {Textfield} from 'app/interfaces/textfield';
import {timer} from 'rxjs';
import uuid from 'short-unique-id';
import {formBuilder} from '../form-builder/formBuilder';
import {GeneralPopoverSettingsComponent} from '../general-popover-settings/general-popover-settings.component';
import { SelectedFontSize, SelectedRole} from '../general-popover-settings/general-popover-settings.dto';
import {FormBuilder, FromFieldType} from './form-builder-settings.dto';
import { SelectedFieldEnum } from 'app/interfaces/fields.dto';
import { PopoverSettingMenu } from '../../edit-template/edit-template.dto';
import { EditorEmitterService } from '../../events/editor-emitter.service';
import { EventHandlersService } from '../../edit-template/event-handler.service';

declare const $;
@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-form-builder-settings',
  templateUrl: './form-builder-settings.component.html',
  styleUrls: ['./form-builder-settings.component.scss'],
  providers: [formBuilder, GeneralPopoverSettingsComponent]
})

export class FormBuilderSettingsComponent implements OnChanges {

  /**
   * 
   * @param template 
   * @param formBuilder 
   * @param elementRef 
   * @param globalService 
   */
  constructor(
    private eventHandlersService: EventHandlersService,
    private formBuilder: formBuilder,
    private elementRef: ElementRef,
    private globalService: GlobalService,
    private generalPopoverSettings: GeneralPopoverSettingsComponent,
    private _translocoService:TranslocoService,
    private domHelperService: DomHelperService,
    private editorEmitterService: EditorEmitterService
  ) { }
  public uuid = new uuid({ length: 6, dictionary: 'number' });
  @Input() data: Array<[]>;
  public formBuilderUuid: number = 0;
  public selectedFormFieldType: number = 0;
  public formBuilderFieldsPopup: boolean = false;
  private formBlock:Block;
  public role_id:number = 0;
  formFieldTypes: Array<FromFieldType> = [
    { id: 0, name: this._translocoService.translate("Add field title (user right menu page, stats tab) - Add field"), type: 'addfield', },
    { id: 1, name: this._translocoService.translate("Content text field (Template/Document - section) - Text Field"), type: 'text', },
    { id: 2, name: this._translocoService.translate("Datepicker field label (Template/Document - section) - Datepicker"), type: 'datepicker' },
    { id: 3, name: this._translocoService.translate("Droplist field label (Template/Document - section) - Droplist"), type: 'droplist' },
    { id: 4, name: this._translocoService.translate("Checkbox field label (Template/Document - section) - Checkbox"), type: 'checkbox' },
    { id: 5, name: this._translocoService.translate("List field label (Template/Document - section) - List"), type: 'multichoice' },
    { id: 6, name: this._translocoService.translate("Content signing box field (Template/Document - section) - Signing Box"), type: 'signature' },
  ];
  public SelectedFieldEnum = SelectedFieldEnum;
  public selectedFontSize: string = '14';
  public selectFontSize: Array<SelectedFontSize> = [
    { id: 1, name: '8', fieldClass: '8' },
    { id: 2, name: '10', fieldClass: '10' },
    { id: 3, name: '12', fieldClass: '12' },
    { id: 4, name: '14', fieldClass: '14' },
    { id: 5, name: '16', fieldClass: '16' },
    { id: 6, name: '18', fieldClass: '18' },
    { id: 7, name: '20', fieldClass: '20' },
    { id: 8, name: '22', fieldClass: '22' },
    { id: 9, name: '24', fieldClass: '24' },
    { id: 10, name: '26', fieldClass: '26' },
    { id: 11, name: '28', fieldClass: '28' },
    { id: 12, name: '30', fieldClass: '30' },
  ];

  public formBuilders: Array<FormBuilder> = [
    {
      "id": 1,
      "name": this._translocoService.translate("Content text field (Template/Document - section) - Text Field"),
      "type": "text",
      "field": "text-field",
      "column": "50"
    },
    {
      "id": 2,
      "name": this._translocoService.translate("Checkbox field label (Template/Document - section) - Checkbox"),
      "type": "checkbox",
      "field": "checkbox-field",
      "column": "100"
    },
    {
      "id": 3,
      "name": this._translocoService.translate("Droplist field label (Template/Document - section) - Droplist"),
      "type": "droplist",
      "field": "droplist-field",
      "column": "50"
    },
    {
      "id": 4,
      "name": this._translocoService.translate("List field label (Template/Document - section) - List"),
      "type": "multichoice",
      "field": "multichoice-field",
      "column": "50"
    },
    {
      "id": 5,
      "name": this._translocoService.translate("Datepicker field label (Template/Document - section) - Datepicker"),
      "type": "datepicker",
      "field": "datepicker-field",
      "column": "50"
    },
    {
      "id": 6,
      "name": this._translocoService.translate("Content signature field (Template/Document - section) - Signature Field"),
      "type": "signature",
      "field": "signature-field",
      "column": "100"
    },
  ];

  public formBuilderFields: Array<Field> = [];

  /**
   * update the form builder settings
   */
  async updateSettings() {
    this.formBuilderUuid = this.data['uuid'];
    this.formBlock = this.globalService.fields_data['blocks'][this.formBuilderUuid];
    this.createFields();
    this.role_id = typeof this.formBlock != 'undefined' ? this.formBlock.role_id : 0;
    await this.generalPopoverSettings.setupAllFields();
  }

  /**
   * component emitter when any changes in component
   * @param changes 
   */
  // eslint-disable-next-line @angular-eslint/contextual-lifecycle
  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.data = changes['data'].currentValue;
      this.updateSettings();
    }
  }

  /**
   * close the for bulder righr side menu
   */
  clsoe() {
    this.eventHandlersService.triggerEditorSideMenu({}, 'DEFAULT');
  }

  /**
   * add the form builder fields
   * @param form 
   */
  addFormFeilds(form: FormBuilder) {
    const uuid = this.uuid();
    let field = {};
    const options = [{ name: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option")+' 1', id: this.uuid(), value: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option")+' 1', meta_data_id:0 }, { name: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option")+' 2', id: this.uuid() , value: this._translocoService.translate("Content drop list option menu - (Template/Document - section) - Option")+' 2', meta_data_id:0 }];
    const formBuilderUuid = this.formBuilderUuid;
    this.formBuilder.addFormBuilderField({uuid, type:form.type, options, formBuilderUuid}, (uuid) => {
      if (form.field == 'text-field') {
        field = Textfield.tag({type_of:'field',uuid:uuid,field_info:'custom_field',field_required:1,column:"50"});
      } else if (form.field == 'datepicker-field') {
        field = DatepickerField.tag({type_of:'field',uuid:uuid,field_info:'custom_field',field_required:1,column:"50"});
      } else if (form.field == 'checkbox-field') {
        field = Checkboxfield.tag({type_of:'field',uuid:uuid,field_info:'custom_field',field_required:1});
      } else if (form.field == 'droplist-field') {
        field = DroplistField.tag({type_of:'field',uuid:uuid,field_info:'custom_field',field_required:1,column:"50"});
      } else if (form.field == 'multichoice-field') {
        field = MultichoiceField.tag({type_of:'field',uuid:uuid,field_info:'custom_field',field_required:1,options:options,column:"50"});
      } else if (form.field == 'signature-field') {
        field = Signaturefield.tag({select_type_text: this._translocoService.translate('Content signature field (Template/Document - section) - Signature Field'), value:this.globalService.user_settings.signature ,type_of:'field',uuid:uuid,field_info:'custom_field',field_required:1});
      }
      this.FormFieldsPopup(false);
      this.globalService.fields_data[uuid] = field;
      this.formBlock.fields = [...this.formBlock.fields, uuid];
      this.formBuilderFields.push(field);
      if (form.field == 'datepicker-field') {
        this.globalService.initializeFlatpicker(document.querySelector('[uuid="' + uuid + '"] input'));
      } else if (form.field == 'signature-field') {
        this.domHelperService.initializeEventListener('.generate-signature', 'click', 'generateSignatureForSender');
      }
      this.domHelperService.initializeEventListener(document.querySelectorAll('.droplist-menu'), 'click', 'openDropListMenu', { role_id: 0 });
      this.domHelperService.initializeEventListener(document.querySelectorAll('.search-drop-value'), 'keyup', 'searchDropDownLabelOnKeyUp', { role_id: 0 });
      this.domHelperService.initializeEventListener('.text-tag-editor,.text-field-input,.text-field-textarea', 'keyup', 'updateFieldOnKeyUp', { role_id: 0 });
      this.domHelperService.initializeEventListener('.text-tag-editor,.text-field-input,.text-field-textarea', 'blur', 'updateFieldOnBlur', { role_id: 0 });
      this.domHelperService.initializeEventListener(document?.querySelectorAll('.multiChoice-box'), 'click', 'multiChoiceAction', { role_id: 0 });
      this.domHelperService.initializeEventListener(document.querySelectorAll('.checkbox-field-box'), 'click', 'toggleCheckBox', { role_id: 0 });
      this.initSortAble();
      this.editorEmitterService.setUnsavedChangesFlag(true);
    });

  }

  /**
   * show the form field popup
   * @param boolean 
   */
  FormFieldsPopup(boolean: boolean) {
    this.formBuilderFieldsPopup = boolean;
  }

  /**
   * create the form builder fields
   */
  createFields() {
    this.formBuilderFields = [];
    if (!this.formBlock) {
      console.warn('[createFields] form block missing for uuid', this.formBuilderUuid);
      return;
    }
    const fields = this.formBlock.fields;
    for (let index = 0; index < fields.length; index++) {
      const field = fields[index];
      if (this.globalService.fields_data[field]){
        this.formBuilderFields.push(this.globalService.fields_data[field]); 
      }
    }
    this.initSortAble();
  }

  initSortAble(){
    const that = this.allowedSelf();
    timer(600)
    .subscribe({
      next : () => {
        $('.added-form-fields-box').sortable(
          {
            handle: '.sort-form-fields',
            update: function () {
              that.autoSortFormBuilderFields();
            }
          }
        );
      },  
    })
  }

  allowedSelf(){
    return this;
  }

  /**
   * short the form buider fields
   */
  autoSortFormBuilderFields() {
    let recreateFeilds = '';
    const signaturePoints = [];
    const fieldUuid = [];
    for (let index = 0; index < this.elementRef.nativeElement.querySelectorAll('.added-form-fields-box > *').length; index++) {
      const element = this.elementRef.nativeElement.querySelectorAll('.added-form-fields-box > *')[index];
      const formElement = document.querySelector('.form-builder-table[uuid="' + element.getAttribute('uuid') + '"]');
      fieldUuid.push(element.getAttribute('uuid'));
      formElement.querySelector('input')?.setAttribute('value', formElement.querySelector('input').value);
      if (formElement.querySelector('textarea')) {
        formElement.querySelector('textarea').innerHTML = formElement.querySelector('textarea').value;
      }
      if (formElement.classList.contains('signature-field')) {
        if (this.globalService.signatureObjects[formElement.getAttribute('uuid')]) {
          signaturePoints.push(this.globalService.signatureObjects[formElement.getAttribute('uuid')].toData());
        }
      }
      recreateFeilds += formElement.outerHTML;
    }
    document.querySelector('.editor' + this.formBuilderUuid + ' .form-builder-parent-container').innerHTML = recreateFeilds;
    this.globalService.initializeFlatpicker(document.querySelectorAll('.editor' + this.formBuilderUuid + ' .form-builder-parent-container .datepicker-field'));
    this.globalService.updateBlock(this.formBuilderUuid,{fields:fieldUuid});
  }

  /**
  * select role for allow edit on signing area 
  */
  selectRole(role: SelectedRole) {
    this.formBlock = this.globalService.updateBlock(this.formBuilderUuid, { role_id: role.id });
  }

  openFieldBlockSettings(uuid: string) {
    const field:Field = this.globalService.fields_data[uuid];
    const field_name = field?.field_name;
    const selected_field = field?.selected_field;
    this.editorEmitterService.triggerOpenMenuAction({rightMenuType:PopoverSettingMenu.popoverSettingMenu, fieldSettings:{
        uuid,
        field_name,
        selected_field,
        isFormBuilder: 1, 
        formUuid: this.formBuilderUuid
    }});
  }
}
